<template>
  <Layout>
    <template #sidebar>
      <RouterView name="sidebar" />
    </template>

    <template #default="{ showMenu }">
      <div class="flex flex-col h-full">
        <header class="py-2 px-4 bg-white border-b z-20">
          <div class="flex mx-auto gap-4 items-center">
            <div class="flex-none flex gap-4 items-center">
              <BaseButton ghost class="lg:hidden" @click="showMenu">
                <FontAwesomeIcon icon="bars" />
              </BaseButton>
              <div>
                <RouterLink v-if="$user.membershipsCount > 1 || $isAdminOrSuperAdmin" to="/">
                  <h6 class="text-black text-base">Switch Account</h6>
                </RouterLink>
              </div>
            </div>
            <div v-if="$user" class="flex-none ml-auto">
              <QuickMenu />
            </div>
          </div>
        </header>
        <main class="flex flex-1 flex-col overflow-y-auto h-full">
          <TransitionPage>
            <RouterView :key="$route.params.accountId" />
          </TransitionPage>
        </main>
      </div>
    </template>
  </Layout>
</template>

<script>
import QuickMenu from '@/components/Users/QuickMenu.vue';
import Layout from '@/layouts/OffCanvasLayout.vue';
import store from '@/store';
import { authUser } from '@/store/authHelpers';

import TransitionPage from '@/components/TransitionPage.vue';

export default {
  name: 'Home',
  components: {
    Layout,
    TransitionPage,
    QuickMenu,
  },
  async beforeRouteEnter(to, from, next) {
    const { dispatch } = store;
    await dispatch('setup');
    const { currentAccountId = null, membershipsCount } = authUser() || {};
    if (to.name === 'home') {
      if (from.fullPath === '/') {
        if (currentAccountId && membershipsCount && membershipsCount === 1) {
          return next({
            name: 'accounts.show',
            replace: true,
            params: { accountId: currentAccountId },
          });
        }
      }
    }
    return next();
  },
};
</script>
